export const DOCUMENT_ACTIONS = {
    DOCUMENTS_LIST : "DOCUMENTS_LIST",
    USER_DOCUMENTS_LIST : "USER_DOCUMENTS_LIST"
}